import React from 'react';
import {useSelector} from 'react-redux';

import {IStore} from 'redux/interface';
import {SystemLanguage} from 'utils/constants/constants';

import './styles.scss';

declare global {
  interface Window {
    rubyApi?: {
      on: (event: string, callback: () => void) => void;
    };
    purechatApi?: {
      set: (key: string, value: unknown) => void;
    };
  }
}

function openRubyChat() {
  // chatbox:ready fires once, early during page load - by the time a visitor can
  // click this button, it has almost always already fired, so purechatApi is
  // already live. Only fall back to queuing via the on() stub for the rare case
  // where a click lands before the async widget script has finished loading.
  if (window.purechatApi) {
    window.purechatApi.set('chatbox.visible', true);
    window.purechatApi.set('chatbox.expanded', true);

    return;
  }

  window.rubyApi?.on('chatbox:ready', () => {
    window.purechatApi?.set('chatbox.visible', true);
    window.purechatApi?.set('chatbox.expanded', true);
  });
}

export const RubyChatLauncher: React.FunctionComponent = () => {
  const {locale} = useSelector((state: IStore) => state.translation);
  const label = locale === SystemLanguage.Spanish ? 'Chatear con soporte' : 'Live chat';

  return (
    <button
      type="button"
      className="ruby-chat-launcher"
      onClick={openRubyChat}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 11.5a8.38 8.38 0 0 1-9 8.5 8.5 8.5 0 0 1-3.8-.9L3 20l1.9-5.2A8.5 8.5 0 0 1 12 3a8.38 8.38 0 0 1 9 8.5z"/>
      </svg>
      {label}
    </button>
  );
};
